/**
 * What: Shopify micro surveys merchant-facing copy.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentMicroSurveysCopy = {
    microSurveysMicroSurveyEditor: {
        purchaseBarrier001: 'Purchase barrier',
        useCase002: 'Use case',
        psychographicSegment003: 'Psychographic segment',
        noInterpretation004: 'No interpretation',
        microSurveyCannotBeSaved005: 'Micro-survey cannot be saved',
        microSurveyBuilder006: 'Micro-survey builder',
        authorOneLowFrictionStorefront007: 'Author one low-friction storefront question for the trigger paths the current pixel can execute.',
        trigger008: 'Trigger',
        questionType009: 'Question type',
        question010: 'Question',
        choices011: 'Choices',
        remove012: 'Remove',
        addChoice013: 'Add choice',
        saveMicroSurvey014: 'Save micro-survey',
        cancel015: 'Cancel',
    },
    microSurveysMicroSurveyList: {
        active001: 'Active',
        archived002: 'Archived',
        archiveMicroSurvey003: 'Archive micro-survey',
        choices004: 'choices',
        noMicroSurveysYet005: 'No micro-surveys yet',
        createASupportedStorefrontSurvey006: 'Create a supported storefront survey so the Web Pixel has an active payload to fetch.',
        loadingMicroSurveys007: 'Loading micro-surveys',
        unableToLoadMicroSurveys008: 'Unable to load micro-surveys',
        microSurveys009: 'micro-surveys',
        retry010: 'Try again',
    },
    microSurveysMicroSurveysPage: {
        microSurveyUpdated001: 'Micro-survey updated',
        microSurveyCouldNotBe002: "Couldn't archive this micro-survey",
        microSurveys003: 'Micro-surveys',
        newMicroSurvey004: 'New micro-survey',
        refresh005: 'Refresh',
        helpModalHeading: 'How micro-surveys work',
        helpModalBody1: 'A micro-survey is one short question shown to shoppers on your storefront, triggered by something they do — like landing on a product page or reaching checkout.',
        helpModalBody2: 'Archiving a survey stops it from being shown. Active surveys appear below with the trigger that runs them.',
    },
};
//# sourceMappingURL=micro-surveys.js.map